import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { PathologyService } from '../pathology.service';

@Component({
    selector: 'app-biopsystats',
    templateUrl: './biopsystats.component.html',
    styleUrls: ['./biopsystats.component.scss'],
    standalone: false
})
export class BiopsystatsComponent implements OnInit {
  report: string;
  startdate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  enddate: Date = new Date();
  results: any = [];

  constructor(public loginService: LoginService, private pathologyService: PathologyService) { }

  ngOnInit(): void {
  }

  getReport(): void {
   /* this.pathologyService.getBiopsyStats(this.report, this.startdate, this.enddate).subscribe(data => {
      this.results = data;
    });*/
  }

  getParams(){
    if(this.results && this.results.length > 0){
      return Object.keys(this.results[0]);
    }
  }

}
